/**
 * Simple wrapper around local storage
 * so that we can change the implementation if we need to
 */
export class StorageService<T> {
  constructor(public key:string) {
  }
  getItem(defaultValue: T = undefined): T {
    var value = JSON.parse(sessionStorage.getItem(this.key) || 'null');
    if (value !== null) {
      return value;
    }
    else {
      if (defaultValue)
        this.setItem(defaultValue);
      return defaultValue;
    }
  }
  setItem(value: T): void {
    sessionStorage.setItem(this.key, JSON.stringify(value));
  }
  removeItem(): void {
    sessionStorage.removeItem(this.key);
  }
  hasItem(): boolean {
    return !!sessionStorage.getItem(this.key);
  }
}
